<template>
  <ModalInputTemplate
    v-if="useModal"
    ref="modalTemplate"
    :btn-text="$t('Tenders.Complete')"
    :data-qa="dataQa"
    :form-data="form"
    :modal-title="`${$t('Tenders.WhyFinish')} #${tender.tenderNumber} ${$t('Tenders.WithoutWinner')}?`">
    <template #activatorBtn="{ open }">
      <MenuItem
        v-if="list"
        class="h11-links"
        :data-qa="`${dataQa}-list-item`"
        icon="cancel"
        :label="$t('Tenders.Complete')"
        @click="open"/>
      <sButton
        v-else
        :data-qa="`${dataQa}-btn`"
        @click="open">
        {{ $t('Tenders.Complete') }}
      </sButton>
    </template>
    <template #formItems>
      <sFormItem
        v-if="isShowSendReasonToParticipants"
        :data-qa="`${dataQa}-form-supplierNotification`"
        prop="addToSupplierNotification">
        <div class="bold mt-2">
          {{ $t('Tenders.SendReasonToParticipants') }}?
        </div>
        <sRadioGroup
          v-model="form.addToSupplierNotification"
          class="mt-2"
          row>
          <sRadio
            class="bold"
            :label="true">
            {{ $t('Tenders.Yes') }}
          </sRadio>
          <sRadio
            class="bold"
            :label="false">
            {{ $t('Tenders.No') }}
          </sRadio>
        </sRadioGroup>
      </sFormItem>
    </template>
    <template #firstBtn="{ text, close }">
      <TenderFinished
        :add-to-supplier-notification="form.addToSupplierNotification"
        :close="close"
        :data-qa="`${dataQa}-form-btn-finis`"
        :tender="tender"
        :text="text"
        :validate="$refs.modalTemplate ? $refs.modalTemplate.checkForm : null"/>
    </template>
  </ModalInputTemplate>
</template>
<script>
import MenuItem from 'components/common/MenuItem.vue'
import TenderFinished from 'components/tenders/dialogs/TenderFinished.vue'
import ModalInputTemplate from 'components/common/dialogs/ModalInputTemplate.vue'


/**
 * Завершение тендера
 */
export default {
  name: 'ModalTenderFinish',
  data() {
    return {
      form: {
        addToSupplierNotification: false
      },
    }
  },
  computed: {
    useModal() {
      return this.tender?.tenderStatus?.id === 3
    },
    isShowSendReasonToParticipants() {
      return this.tender?.hasBids && this.tender?.bids?.length
    },
  },
  components: {
    MenuItem,
    TenderFinished,
    ModalInputTemplate
  },
  props: {
    tender: Object,
    list: Boolean,
    dataQa: {
      type: String,
      default: 'complete-tender'
    }
  },
}
</script>
